<div class="reelsWrapper">
  <ng-container *ngIf="showLoader()">
    <span class="loader"></span>
  </ng-container>

  <ng-container *ngIf="showReels()">
    <app-reels [newsId]="newsId"></app-reels>
  </ng-container>
</div>
